import { useEffect, useRef } from "react";

import { useLocation } from "@remix-run/react";

import { trackEvent } from "~/lib/analytics";

// AIDEV-NOTE: Centralized screen view tracking for SSR + client routing
// Emits "viewed screen" on initial mount and every pathname change.
// Relies on trackEvent auto-enrichment for session/ownership/environment.
export function AnalyticsScreenTracker() {
    const location = useLocation();
    const prevScreenRef = useRef<string | undefined>(undefined);

    useEffect(() => {
        const screen = location.pathname || "/";
        const lastScreen = prevScreenRef.current;

        // Fire page/screen view event
        trackEvent("viewed screen", {
            screen,
            lastScreen,
        });

        // Update ref for next navigation
        prevScreenRef.current = screen;
        // We intentionally only depend on pathname so search/hash changes don't spam
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    return null;
}
